import { create } from 'zustand';

// Định nghĩa các key riêng biệt cho localStorage
const TOKEN_KEY = 'token';
const USER_KEY = 'user';

// Helper functions để tương tác với localStorage
// Hàm lấy token từ localStorage
const getStoredToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    console.error('Error getting token from localStorage:', error);
    return null;
  }
};

// Hàm lấy thông tin user từ localStorage và parse JSON
const getStoredUser = () => {
  try {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error getting user from localStorage:', error);
    return null;
  }
};

// Hàm lưu hoặc xóa token trong localStorage
const setStoredToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch (error) {
    console.error('Error setting token to localStorage:', error);
  }
};

// Hàm lưu hoặc xóa thông tin user trong localStorage
const setStoredUser = (user) => {
  try {
    if (user) {
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(USER_KEY);
    }
  } catch (error) {
    console.error('Error setting user to localStorage:', error);
  }
};

// Tạo store quản lý authentication sử dụng Zustand
const useAuthStore = create((set, get) => ({
  // State - Khởi tạo từ localStorage khi F5
  token: getStoredToken(),        // Token xác thực
  user: getStoredUser(),          // Thông tin người dùng
  isAuthenticated: !!getStoredToken(), // Trạng thái đã xác thực hay chưa

  // Actions
  // Cập nhật token và trạng thái xác thực
  setToken: (token) => {
    setStoredToken(token); // Lưu vào localStorage
    set({ 
      token, 
      isAuthenticated: !!token 
    });
  },

  // Cập nhật thông tin người dùng
  setUser: (user) => {
    setStoredUser(user); // Lưu vào localStorage
    set({ user });
  },

  // Action đăng nhập - cập nhật cả token và user
  login: (token, user) => {
    setStoredToken(token); // Lưu token vào localStorage
    setStoredUser(user);   // Lưu user vào localStorage
    set({
      token,
      user,
      isAuthenticated: true
    });
  },

  // Action đăng xuất - xóa toàn bộ thông tin xác thực
  logout: () => {
    setStoredToken(null); // Xóa token khỏi localStorage
    setStoredUser(null);  // Xóa user khỏi localStorage
    set({
      token: null,
      user: null,
      isAuthenticated: false
    });
  },

  // Action để refresh data từ localStorage (có thể gọi sau khi F5)
  refreshFromStorage: () => {
    const storedToken = getStoredToken();
    const storedUser = getStoredUser();
    
    set({
      token: storedToken,
      user: storedUser,
      isAuthenticated: !!storedToken
    });
  },

  // Action để clear toàn bộ storage và state
  clearStorage: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({
      token: null,
      user: null,
      isAuthenticated: false
    });
  }
}));

export default useAuthStore;